import { Vue2K18nNext } from '@k18n/vue2-k18n-next';
import Vue from 'vue';

var commonLangs = require('@k18n/kibt-fe-creator-language/tags/common/index.json'); // const k18n :any = new Vue2K18nNext({messages:[commonLangs]});


Vue.use(Vue2K18nNext, {
  messages: [commonLangs]
});

var t = function t(key, params) {
  if (params) {
    if (params instanceof Array) {
      var realParams = {};
      params.forEach(function (param, index) {
        realParams[index] = param;
      });
      return Vue.prototype.$k18n({
        id: key,
        params: realParams
      });
    }

    return Vue.prototype.$k18n({
      id: key,
      params: params
    });
  }

  return Vue.prototype.$k18n({
    id: key
  });
};

Vue.prototype.$t = t;